import { useMemo, useCallback } from 'react'

import {
  UseCommonPropsInputProps,
  UsePlatformSpecificPropsWebOutput,
} from '../types/darkcove'

import config from '@config'

import { getLocalStorageItem, setLocalStorageItem } from '@utils/localStorage'

const {
  video: { storageKeyVideoPlayerSettings },
} = config

export type UsePersistentSettingsInputProps = Pick<
  UseCommonPropsInputProps,
  'isBlickTV'
>

export type UsePersistentSettingsOutputProps = {
  persistentPlayerSettings: Pick<
    UsePlatformSpecificPropsWebOutput,
    'startWithCaptions'
  >
  onCaptionsChange: (options: { startWithCaptions: boolean }) => void
}

type UsePersistentSettings = (
  args: UsePersistentSettingsInputProps
) => UsePersistentSettingsOutputProps

const usePersistentSettings: UsePersistentSettings = ({ isBlickTV }) => {
  const persistentPlayerSettings = useMemo(() => {
    // settings should be persistant only for article videos
    return isBlickTV
      ? {}
      : getLocalStorageItem<
          UsePersistentSettingsOutputProps['persistentPlayerSettings']
        >(storageKeyVideoPlayerSettings) ?? {}
  }, [isBlickTV])

  const onCaptionsChange = useCallback(
    ({ startWithCaptions }: { startWithCaptions?: unknown } = {}) => {
      if (!isBlickTV) {
        // save player settings to the storage
        setLocalStorageItem(storageKeyVideoPlayerSettings, {
          ...getLocalStorageItem(storageKeyVideoPlayerSettings),
          startWithCaptions: startWithCaptions,
        })
      }
    },
    [isBlickTV]
  )

  return {
    persistentPlayerSettings,
    onCaptionsChange,
  }
}

export default usePersistentSettings
